import React from 'react';

import { NumberLabel, Wrapper } from './styles';

interface GroupCountProps {
    count?: number;
    label: string;
    onClick?(e: React.MouseEvent<HTMLElement>): void;
}

const GroupCount = ({ count, label, onClick }: GroupCountProps) => {
    if (count === undefined) return null;
    return (
        <Wrapper $clickable={!!onClick} onClick={onClick}>
            {label} <NumberLabel>{isNaN(count) ? '-' : count.toLocaleString()}</NumberLabel>
        </Wrapper>
    );
};

export default GroupCount;
